import { Amplify } from 'aws-amplify';
import type { ResourcesConfig } from 'aws-amplify';

/**
 * AWS Amplify Configuration
 *
 * Configuration values are injected at build time via Vite environment variables.
 * These variables are set by the deployment workflow from CloudFormation stack outputs.
 *
 * Required environment variables:
 * - VITE_USER_POOL_ID: Cognito User Pool ID
 * - VITE_USER_POOL_CLIENT_ID: Cognito User Pool Client ID
 * - VITE_API_ENDPOINT: API Gateway endpoint URL
 * - VITE_AWS_REGION: AWS region
 */

// Validate required environment variables
const requiredEnvVars = {
  userPoolId: import.meta.env.VITE_USER_POOL_ID,
  userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID,
  apiEndpoint: import.meta.env.VITE_API_ENDPOINT,
  awsRegion: import.meta.env.VITE_AWS_REGION || 'us-west-2',
};

const missingVars = Object.entries(requiredEnvVars)
  .filter(([_, value]) => !value)
  .map(([key]) => key);

if (missingVars.length > 0) {
  throw new Error(
    `Missing required environment variables: ${missingVars.join(', ')}. ` +
      'Ensure VITE_* variables are set during build.'
  );
}

const awsConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: requiredEnvVars.userPoolId,
      userPoolClientId: requiredEnvVars.userPoolClientId,
      signUpVerificationMethod: 'code' as const,
      loginWith: {
        email: true,
      },
    },
  },
};

// Initialize Amplify
Amplify.configure(awsConfig);

export { awsConfig };
